import { render, staticRenderFns } from "./VoucherExamsNew.vue?vue&type=template&id=2628bfb4"
import script from "./VoucherExamsNew.vue?vue&type=script&lang=js"
export * from "./VoucherExamsNew.vue?vue&type=script&lang=js"
import style0 from "./VoucherExamsNew.vue?vue&type=style&index=0&id=2628bfb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports